// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__9SXt2","colMaxWidth":"Table_colMaxWidth__1QSN8"};